
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  methods: {
    translateText: async function (ev) {
      const self = this;
      const l = this.$(ev.target).data('lng');
      this.translated = this.translated || {};
      this.translated[l] = !!!this.translated[l];

      for (let i in this.translated) {
        if (i !== l) {
          this.translated[i] = false;
          this.$('.button-translate-' + i).attr('src', 'static/img/flag_' + i + '.png');
        }
      }

      if (this.translated[l]) {
        this.$(ev.target).attr('src', 'static/img/flag_translate.png'); // traduce

        this.$('.build-text').text('I\'m translating ...');
        const APIKey = 'AIzaSyB8AY9p2GiPEq4iQ7gNmh5IRqI7MfKyy28';
        const url = 'https://translation.googleapis.com/language/translate/v2?key=' + APIKey;
        const data = {
          target: self.$(ev.target).data('lng'),
          q: [self.event.description_short || '', self.event.text || ''],
          format: 'text'
        };
        const options = {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json'
          }
        };
        let res = await fetch(url, options);

        if (res.ok) {
          let resp = await res.json();
          self.$('.poi-edit-event-description').text(resp.data.translations[0].translatedText);
          self.$('.poi-edit-event-text').text(resp.data.translations[1].translatedText);
        } else {
          self.$('.poi-edit-event-description').text(self.event.description);
          self.$('.poi-edit-event-text').text(self.event.text);
        }
      } else {
        this.$(ev.target).attr('src', 'static/img/flag_' + l + '.png'); // torna a originale

        self.$('.poi-edit-event-description').text(self.event.description_short);
        self.$('.poi-edit-event-text').text(self.event.text);
      }
    },
    showImage: function (idx) {
      const sw = this.$app.swiper.get('.build-swiper-event');
      sw.slideTo(idx);
    },
    formatDatetime: function (d) {
      const s = d.toDateString();
      const t = this.formatTime(d);
      return s + ' ' + t;
    },
    formatTime: function (d) {
      let h = d.getHours();
      let m = d.getMinutes();
      if (h < 10) h = '0' + h;
      if (m < 10) m = '0' + m;
      return h + ':' + m;
    },
    getEvent: async function () {
      const idpoi = this.$route.params.poi;
      const self = this;
      const app = this.$app;
      const $ = this.$;
      let event;

      if (this.$route.query.from) {
        event = await myApp.server.get('imc/event/' + this.$route.params.ev);
        event.text = event.description;
        event.description = event.description_short;
        event.title = event.caption;
      } else {
        event = JSON.parse(this.$route.params.ev);
      }

      event.datetime_init = event.datetime_init * 1;
      event.datetime_end = event.datetime_end * 1;
      const dti = new Date(event.datetime_init);
      const dte = new Date(event.datetime_end);
      event.dt1 = event.datetime_init ? self.formatDatetime(dti) : '';
      event.dt2 = event.datetime_end ? ' / ' + self.formatDatetime(dte) : '';
      event.web = event.web && !event.web.match(/^https?\:\/\//) ? 'http://' + event.web : event.web;
      event.fb = event.fb && !event.fb.match(/^https?\:\/\//) ? 'http://' + event.fb : event.fb;
      event.instagram = event.instagram && !event.instagram.match(/^https?\:\/\//) ? 'http://' + event.instagram : event.instagram;
      self.$setState({
        event: event
      }).then(() => {
        const sw = app.swiper.get('.build-swiper-event');
        sw.update();

        if (event.poitype === 'festival') {
          const provider = new myApp.OpenStreetMapProvider();
          const map = new L.Map('detail-map', {
            zoomControl: false,
            dragging: false
          });
          myApp.detailMap = map;
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a class="external" target="_system" ' + 'href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          }).addTo(map);
          if (myApp.realPosition) L.marker(myApp.realPosition, {
            icon: myApp.GeoIcon
          }).addTo(map);
          const icon = L.icon({
            iconUrl: 'static/markers/disco-3.png',
            iconSize: [56, 56],
            iconAnchor: [28, 56],
            popupAnchor: [0, 0]
          });
          const latLng = [event.latitude, event.longitude];

          if (myApp.realPosition && false) {
            map.fitBounds([latLng, myApp.realPosition]);
          } else {
            map.setView(latLng, 15);
          }

          L.marker(latLng, {
            icon: icon
          }).addTo(map);
        }

        $('video').forEach(el => {
          el.load();

          el.onplay = () => {
            if (el.requestFullscreen) {
              console.log('requestFullscreen');
              el.requestFullscreen();
            } else if (el.webkitRequestFullscreen) {
              /* Safari */
              console.log('webkitRequestFullscreen');
              el.webkitRequestFullscreen();
            }
          };
        });
      });
    },

    imgBrowser(idx) {
      const self = this,
            app = this.$app,
            $ = this.$;
      const photoBrowser = app.photoBrowser.create({
        photos: self.event.images
      });
      photoBrowser.open(idx);
    },

    showVideo(ev) {// ...
    },

    share() {
      const self = this,
            app = this.$app,
            $ = this.$;
      let url = 'https://app.infomycity.eu/?x=';
      let qs = '/poi-event/' + this.idpoi + '/' + this.event.id + '/?from=1';
      url += encodeURIComponent(qs);

      if (app.device.cordova) {
        const options = {
          message: 'Visit the following link:',
          subject: 'Share link',
          url: url,
          chooserTitle: 'Share link'
        };

        var onSuccess = function (result) {
          console.log("Share completed? " + result.completed);
          console.log("Shared to app: " + result.app); // reimposta dimensione viewport (se pubblicità attiva)
          //window.location.reload();
        };

        var onError = function (msg) {
          console.log("Sharing failed with message: " + msg);
        };

        window.plugins.socialsharing.shareWithOptions(options, onSuccess, onError);
      } else {
        app.dialog.alert('Social share non disponibile.', () => window.open(url));
      }
    }

  },
  data: function () {
    return {
      lng: lng,
      event: {},
      images: [],
      idpoi: this.$route.params.poi,
      weekdays: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
    };
  },
  on: {
    pageBeforeIn: function () {
      this.getEvent();
      myApp.weekdays = this.weekdays;
    }
  },

  mounted() {
    if (!this.$app.device.cordova || !myApp.currentPoi) {
      myApp.server.get('imc/item/' + this.$route.params.poi + '/?complete').then(poi => myApp.currentPoi = poi).catch(err => console.log(err));
    }
  },

  id: '3a2c9bb913',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page"> \n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner sliding">\n        <div class="left">\n          ';
      r += Template7Helpers.js_if.call(ctx_1, "this.event.poitype === 'festival'", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            <span class="ios-only">Back</span>\n          </a>\n          ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <a href="/disco/';
          r += c(ctx_2.idpoi, ctx_2);
          r += '/" class="link">\n            <i class="icon icon-back"></i>\n            <span class="ios-only">Back</span>\n          </a>\n          ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n        <div class="right">\n          <a href="/menu_events/';
      r += c(ctx_1.idpoi, ctx_1);
      r += '/';
      r += c(ctx_1.event.id, ctx_1);
      r += '/" class="button button-fill button-round bg-imc text-color-yellow">';
      r += c(ctx_1.lng.book, ctx_1);
      r += '</a>\n        </div>\n      </div>\n    </div>\n\n    <div class="page-content page-content-banner poi-event-body" style="max-width: 100%; overflow-x: hidden;">\n      <div class=\'poi-event-dt1\'>';
      r += c(ctx_1.event.dt1, ctx_1);
      r += ' ';
      r += c(ctx_1.event.dt2, ctx_1);
      r += '</div>\n      <div class=\'poi-event-title\'>';
      r += c(ctx_1.event.title, ctx_1);
      r += '</div>\n      <div class="build-slideshow">\n        <div class="build-swiper build-swiper-event swiper-container swiper-init">\n          <div class="swiper-wrapper">\n            ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.event.images, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="swiper-slide">\n              <div @click="imgBrowser(';
          r += c(data_2 && data_2.index, ctx_2);
          r += ')" class="contain build-slideshow-slide" style="background-image: url(';
          r += c(ctx_2, ctx_2);
          r += ');"></div>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          </div>\n        </div>\n      </div>\n\n      <div style="border-top: solid 1px #aaa; max-width: 100%;">\n        ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.event.video, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n\n        <video class="video_cover build-image" \n               controls\n               style="background-image: url(';
          r += c(ctx_2.url, ctx_2);
          r += '?poster)">\n          <source src="';
          r += c(ctx_2.url, ctx_2);
          r += '" type="video/mp4"> \n        </video>\n\n        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n      </div>\n\n      <!-- TRANSLATE -->\n      <div style="height: 15px"></div>\n      <div class=\'translate-group\'>\n        <img @click="translateText" data-lng=\'en\' class="button-translate button-translate-en" src="static/img/flag_en.png" alt=""/>\n        <img @click="translateText" data-lng=\'fr\' class="button-translate button-translate-fr" src="static/img/flag_fr.png" alt=""/>\n        <img @click="translateText" data-lng=\'it\' class="button-translate button-translate-it" src="static/img/flag_it.png" alt=""/>\n        <img @click="translateText" data-lng=\'es\' class="button-translate button-translate-es" src="static/img/flag_es.png" alt=""/>\n        <img @click="translateText" data-lng=\'de\' class="button-translate button-translate-de" src="static/img/flag_de.png" alt=""/>\n      </div>\n\n\n      <div class=\'block\'>\n        <div class="poi-edit-event-description">';
      r += c(ctx_1.event.description_short, ctx_1);
      r += '</div>\n      </div>\n      <div class=\'block\'>\n        <div class="poi-edit-event-text">';
      r += c(ctx_1.event.text, ctx_1);
      r += '</div>\n      </div>\n      <div class="block">\n        <a href="#" @click="share">\n          <img class="share-icon" src="static/share-white.png" alt=""/>\n          ';
      r += c(ctx_1.lng.shareLink, ctx_1);
      r += '\n        </a>\n      </div>\n\n      ';
      r += Template7Helpers.js_if.call(ctx_1, "this.event.poitype === 'festival'", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n      <!-- CONTACTS -->\n      <div class="event-website-contacts">\n        <p>\n          <a href="https://www.google.com/maps/dir/?api=1&destination=';
          r += c(ctx_2.event.latitude, ctx_2);
          r += ',';
          r += c(ctx_2.event.longitude, ctx_2);
          r += '" \n             class="external button" target="_system">\n            <i class="f7-icons" style="font-size: 14px">placemark</i> &nbsp;\n            ';
          r += c(ctx_2.event.address, ctx_2);
          r += '\n            ';
          r += c(ctx_2.event.city, ctx_2);
          r += '\n          </a>\n        </p>\n\n        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.event.phone, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <p>\n          <a href="tel:';
              r += c(ctx_3.event.phone.replace(/\s/g, ''), ctx_3);
              r += '"  target="_system" class="link external button">\n            <i class="f7-icons" style="font-size: 14px">phone</i>  &nbsp;\n            ';
              r += c(ctx_3.event.phone, ctx_3);
              r += '\n          </a>\n        </p>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' \n\n        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.event.email, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <p>\n          <a href="mailto:';
              r += c(ctx_3.event.email, ctx_3);
              r += '"  target="_system" class="link external button">\n            <i class="f7-icons" style="font-size: 14px">at</i>  &nbsp;\n            ';
              r += c(ctx_3.event.email, ctx_3);
              r += '\n          </a>\n        </p>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' \n\n        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.event.web, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <p>\n          <a href="';
              r += c(ctx_3.event.web, ctx_3);
              r += '" class="button link external"  target="_system">\n            <i class="f7-icons" style="font-size: 14px">globe</i>  &nbsp;\n            ';
              r += c(ctx_3.event.web, ctx_3);
              r += '\n          </a>\n        </p>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.event.fb, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <p>\n          <a href="';
              r += c(ctx_3.event.fb, ctx_3);
              r += '" class="button link external"  target="_system">\n            <i class="f7-icons" style="font-size: 14px">logo_facebook</i>  &nbsp;\n            ';
              r += c(ctx_3.event.fb, ctx_3);
              r += '\n          </a>\n        </p>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.event.instagram, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <p>\n          <a href="';
              r += c(ctx_3.event.instagram, ctx_3);
              r += '" class="button link external"  target="_system">\n            <i class="f7-icons" style="font-size: 14px">logo_instagram</i>  &nbsp;\n            ';
              r += c(ctx_3.event.instagram, ctx_3);
              r += '\n          </a>\n        </p>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n      </div>\n\n      <!-- Info / orari -->\n      <h4 class="mb-0 margin-left theme-dark">';
          r += c(ctx_2.lng.open, ctx_2);
          r += '</h4>\n      <table class="theme-dark margin-horizontal margin-top">\n        ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.event.params.opening, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <tr>\n          <td>\n            ';
              r += Template7Helpers.js.call(ctx_3, "lng[myApp.weekdays[@index]]", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n          </td>\n          <td>\n            ';
              r += Template7Helpers.js_if.call(ctx_3, "this.morning || this.evening", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n            ';
                  r += c(ctx_4.morning || '', ctx_4);
                  r += '  ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.evening, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += c(ctx_5.evening, ctx_5);
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += ' \n            ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n            ';
                  r += c(root.lng.closed, ctx_4);
                  r += '\n            ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n          </td>\n        </tr>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n      </table>\n\n      <div style="width: 100%; height: 33vh; background-color:#ccc; margin-top: 15px" id="detail-map"></div>\n\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' <!-- /this.event.poitype === \'festival\' -->\n\n      <div style="height: 120px"></div>\n\n      <div id="detail-buttons-bottom-group">\n        <a href="/menu_events/';
      r += c(ctx_1.idpoi, ctx_1);
      r += '/';
      r += c(ctx_1.event.id, ctx_1);
      r += '/"\n           class="link popup-close button button-large button-fill button-round bg-color-imc text-color-white button-booking-fixed">\n          ';
      r += c(ctx_1.lng.book, ctx_1);
      r += '\n          <img width="22" src="static/check.png" alt=""/>\n        </a>\n        <a href="/chat/';
      r += c(ctx_1.idpoi, ctx_1);
      r += '/" \n           class="button button-large button-fill button-round bg-color-primary text-color-imc button-chat-fixed">\n          <i class="icon f7-icons button-fixed-chat ios-only">chat_bubble_text_fill</i>\n          <i class="icon material-icons button-fixed-chat md-only">chat</i>\n        </a>\n      </div>\n\n    </div>\n\n  </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    